<template>
  <div>
    <div class="contents">
      <div class="filter-box-3">
        <div>
          <select aria-label="" v-model="searchData.pagesize">
            <option value="10" selected>
              {{ $t("filter.common.sort_by_10") }}
            </option>
            <option value="50">{{ $t("filter.common.sort_by_50") }}</option>
            <option value="100">
              {{ $t("filter.common.sort_by_100") }}
            </option>
          </select>
        </div>
        <div>
          <select
            name="type"
            class="form-select"
            v-model="searchData.pointtype"
          >
            <option value="0">
              {{ $t("filter.common.total") }}
            </option>
            <option value="1">
              {{ $t("title.common.oom_point") }}
            </option>
            <option value="2">
              {{ $t("title.common.standard_point") }}
            </option>
          </select>
        </div>
        <div class="input-group">
          <input
            type="text"
            class="form-control-lg"
            :placeholder="$t('title.common.nickname')"
            v-model="searchData.searchtext"
          />
          <input class="btn btn-primary btn-lg search" type="button" value="" />
        </div>
      </div>

      <div v-if="player_info.player_pk" class="row row-cols-auto gx-3 gy-2">
        <div class="col text-point-op">
          {{ $t("title.common.oom_point") }} :
          <span class="fw-bold">{{
            player_info.player_oom_point | comma | suffix("P")
          }}</span>
        </div>
        <div class="col text-point-sp">
          {{ $t("title.common.standard_point") }} :
          <span class="fw-bold">{{
            player_info.player_standard_point | comma | suffix("P")
          }}</span>
        </div>
      </div>

      <div class="table-responsive mt-4">
        <table class="table board">
          <thead>
            <tr>
              <th class="col-auto d-none d-lg-table-cell">
                {{ $t("title.common.number") }}
              </th>
              <th class="col-auto d-lg-table-cell">
                {{ $t("title.common.nickname") }}
              </th>

              <th class="col-auto d-lg-table-cell">
                {{ $t("title.common.point") }}
              </th>

              <th class="col-auto d-none d-lg-table-cell">
                {{ $t("title.common.memo") }}
              </th>
              <th class="col-auto d-none d-lg-table-cell">
                {{ $t("title.common.date") }}
              </th>
              <!-- <th class="col-auto d-none d-lg-table-cell">point Sum</th> -->
              <th class="col-auto d-lg-table-cell">
                <input
                  type="checkbox"
                  v-model="allSelected"
                  @click="selectAll()"
                />
              </th>

              <th class="th-arrow"></th>
            </tr>
          </thead>
          <tbody v-if="pointListCnt">
            <template v-for="(item, index) in pointList">
              <tr :key="index">
                <td class="col-auto d-none d-lg-table-cell">
                  {{ item.no }}
                </td>

                <td
                  class="col-auto more text-start more"
                  @click="searchData.searchtext = item.nickname"
                >
                  {{ item.nickname }}
                </td>

                <td class="col-auto d-lg-table-cell">
                  <div
                    class="text-end text-nowrap"
                    v-if="item.poi_type == 'oom'"
                  >
                    <h6 class="fs-6 text-point-op" title="OOM Point">
                      {{ item.poi_point > 0 ? "+" : "" }}
                      {{ item.poi_point | comma | suffix("P") }}
                    </h6>
                    <small class="text-point-op" title="OOM Point Balance">
                      {{ $t("text.common.tot") }}
                      {{ item.player_oom_point | comma | suffix("P") }}
                    </small>
                  </div>
                  <div
                    class="text-end text-nowrap"
                    v-if="item.poi_type == 'standard'"
                  >
                    <h6 class="fs-6 text-point-sp" title="standard Point">
                      {{ item.poi_point > 0 ? "+" : "" }}
                      {{ item.poi_point | comma | suffix("P") }}
                    </h6>
                    <small class="text-point-sp" title="standard Point Balance">
                      {{ $t("text.common.tot") }}
                      {{ item.player_standard_point | comma | suffix("P") }}
                    </small>
                  </div>
                </td>

                <td class="col-auto d-none d-lg-table-cell">
                  {{ item.poi_action }}
                  {{ item.poi_memo }}
                </td>
                <td class="col-auto d-none d-lg-table-cell text-date">
                  {{ item.timezone_regdate }}
                </td>
                <!-- <td class="col-auto d-none d-lg-table-cell text-end">
                  {{ item.sum_points | comma }}
                </td> -->
                <td class="col-auto d-lg-table-cell">
                  <input
                    type="checkbox"
                    class="form-check-input custom-checkbox"
                    :value="index"
                    v-model="checkedPointidx"
                    @change="updateCheckall()"
                  />
                </td>
                <td class="td-arrow" @click="toggle_tr(index)">
                  <img
                    src="/img/arrow_none_collapsed.png"
                    :class="{ 'btn-toggle-arrow': view_hide === index }"
                  />
                </td>
              </tr>
              <tr
                class="d-lg-none"
                :class="{ show: view_hide === index }"
                :key="index + 'r'"
                v-if="view_hide === index"
              >
                <td colspan="5">
                  <div class="toggle-content">
                    <div class="row">
                      <div class="col-4">{{ $t("title.common.number") }}</div>
                      <div class="col-8">{{ item.no }}</div>
                    </div>

                    <div class="row">
                      <div class="col-4">{{ $t("title.common.memo") }}</div>
                      <div class="col-8">
                        {{ item.poi_action }}
                        {{ item.poi_memo }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">{{ $t("title.common.date") }}</div>
                      <div class="col-8 text-date">
                        {{ item.timezone_regdate | dateformat }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="text-center">
                {{ $t("text.common.no_data") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text>
          <i class="material-icons">keyboard_double_arrow_left</i>
        </template>
        <template #prev-text>
          <i class="material-icons">navigate_before</i>
        </template>
        <template #next-text>
          <i class="material-icons">navigate_next</i>
        </template>
        <template #last-text>
          <i class="material-icons">keyboard_double_arrow_right</i>
        </template>
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          aria-label="Point Delete"
          @click="pointDel"
          >Point Delete</b-button
        >
        <b-button
          size="xl"
          variant="primary"
          aria-label="Point Add"
          @click="
            $refs['point_modal'].modalOuterStyle.zIndex = 9999;
            $refs['point_modal'].show();
          "
          >Point Add</b-button
        >
      </div>
    </div>
    <b-modal id="point_modal" ref="point_modal" no-fade>
      <template #modal-header>
        <h5 class="modal-title">Add Point to members</h5>
        <button
          type="button"
          class="btn-close"
          @click="$refs['point_modal'].hide()"
        ></button>
      </template>

      <div class="hor-type">
        <div class="row border-bottom border-top-dgray">
          <div class="col-lg-3 bg-light row align-items-center">
            <label class="d-table-cell required">Nickname</label>
          </div>
          <div class="col-lg">
            <input
              type="text"
              class="form-control-lg"
              v-model="form.nickname"
            />
          </div>
        </div>
        <div class="row border-bottom">
          <div class="col-lg-3 bg-light row align-items-center">
            <label class="d-table-cell required">Point</label>
          </div>
          <div class="col-lg">
            <input
              type="number"
              class="form-control-lg text-cyan"
              :class="{ 'text-cyan' : form.poi_type === 'oom', 'text-point-op' : form.poi_type === 'standard'}"
              v-model="form.poi_point"
            />
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-lg-3 bg-light row align-items-center">
            <label class="d-table-cell required">Point Type</label>
          </div>
          <div class="col-lg">
            <div class="d-inline-block me-3">
              <input
                class="form-check-input"
                type="radio"
                id="oom"
                value="oom"
                v-model="form.poi_type"
                :checked="form.poi_type == 'oom'"
              />
              <label class="form-check-label" for="oom">OOM Point</label>
            </div>
            <div class="d-inline-block">
              <input
                class="form-check-input"
                type="radio"
                id="standard"
                value="standard"
                v-model="form.poi_type"
                :checked="form.poi_type == 'standard'"
              />
              <label class="form-check-label" for="standard"
                >Standard Point</label
              >
            </div>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col-lg-3 bg-light row align-items-center">
            <label class="d-table-cell required">Comment</label>
          </div>
          <div class="col-lg">
            <input
              type="text"
              class="form-control-lg"
              v-model="form.poi_memo"
            />
          </div>
        </div>
      </div>

      <template #modal-footer="{}">
        <button
          class="btn btn-outline-secondary btn-md w-50"
          type="button"
          aria-label="Close"
          @click="$bvModal.hide('point_modal')"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary btn-md w-50"
          type="button"
          @click="pointAdd"
        >
          Add Point
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/member";
import "@/filter/common";

export default {
  name: "PointAdmin",
  data() {
    return {
      pointList: [],
      playerPoint: [],
      checkedPointidx: [],
      allSelected: false,
      searchData: {
        pointtype:
          this.$route.query.pointtype ||
          (this.$store.state.searchData[this.$route.matched[0].name] &&
            this.$store.state.searchData[this.$route.matched[0].name]
              .pointtype) ||
          "0",
        searchtext:
          this.$route.query.searchtext ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtext) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        pagesize:
          this.$route.query.pagesize ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pagesize) ||
          10,
      },
      form: {
        poi_memo: "",
        nickname: "",
        poi_point: "",
        poi_type: "oom",
        checkedPointItem: [],
      },
      ballance_yn: true,
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      player_info: [],
      view_hide: null,
      pointListCnt: 0,
    };
  },

  methods: {
    getAdminPointList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });

      ax.get_adminpointlist(this.searchData, (data) => {
        console.log(data);
        if (data) {
          this.pointList = data.pointlist;
          this.pointListCnt = data.pointlistcnt;

          this.total_cnt = data.pointlistcnt;
          this.page_total = Math.ceil(
            data.pointlistcnt / this.searchData.pagesize
          );

          this.player_info = data.player_info;
        }
        // else {
        //   this.form.playerNickname = "";
        //   this.form.ownerId = "";
        //   this.ballance_yn = false;
        //   this.pointList = [];
        //   this.playerPoint = [];
        //   this.pointListCnt = 0;
        //   this.page_total = 0;
        // }
      });
    },
    selectAll() {
      this.checkedPointidx = [];
      this.form.checkedPointItem = [];
      // alert(this.allSelected);
      if (!this.allSelected) {
        for (let i = 0; i < this.pointList.length; i++) {
          //if (this.searchData.pagesize > i) {
          this.checkedPointidx.push(i);
          this.form.checkedPointItem.push(
            this.pointList[this.checkedPointidx[i]].poi_pk
          );
          //}
        }
      }
    },
    updateCheckall() {
      console.log(this.pointList.length);
      console.log(this.checkedPointidx.length);
      // this.allSelected = false;
      if (this.pointList.length == this.checkedPointidx.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    // search(v) {
    //   this.searchData.pageno = 1;

    //   this.$store.commit("setSearchData", {
    //     [this.$route.name]: this.searchData,
    //   });
    //   this.getAdminPointList();
    // },
    pointDel() {
      if (this.checkedPointidx.length < 1) {
        alert(this.$i18n.t("alert.common.select_item"));
      } else {
        if (confirm(this.$i18n.t("alert.common.want_to_delete"))) {
          this.form.checkedPointItem = [];
          for (let i = 0; i < this.checkedPointidx.length; i++) {
            this.form.checkedPointItem.push(
              this.pointList[this.checkedPointidx[i]].poi_pk
            );
          }
          console.log("checkedPointItem", this.form);
          ax.remove_point(this.form, (flag, response) => {
            if (flag) {
              alert(response.message);
              this.checkedPointidx = [];
              this.getAdminPointList();
            } else {
              alert(response.message);
            }
          });
        }
      }
    },
    pointAdd() {
      if (!this.form.nickname) {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.nickname"),
          })
        );

        return false;
      }

      if (this.form.poi_point === 0) {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.point"),
          })
        );

        return false;
      }

      if (!this.form.poi_memo) {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.content"),
          })
        );

        return false;
      }

      ax.add_point(this.form, (flag, response) => {
        if (flag) {
          alert(response.message);
          this.form.nickname = "";
          this.form.poi_point = 0;
          this.form.poi_memo = "";
          this.$refs["point_modal"].hide();
          this.getAdminPointList();
        } else {
          /*this.$notify({
              group: 'alert',
              type: 'info',
              title: '정보',
              text: '발송에 실패하였습니다.'
            })*/
          alert(response.message);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
      // ? `?searchtext=${this.searchData.searchtext}`
      // : `?page=${pageNum}&searchtext=${this.searchData.searchtext}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  mounted() {
    this.getAdminPointList();
  },
  watch: {
    "searchData.pointtype": function () {
      this.searchData.pageno = 1;
      this.getAdminPointList();
    },
    "searchData.searchtext": function () {
      this.searchData.pageno = 1;
      this.getAdminPointList();
    },

    "searchData.pageno": function () {
      this.getAdminPointList();
    },
    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.getAdminPointList();
    },
  },
};
</script>
